import { STRINGS } from '@/constants/strings';
import type { MutatePlayerOption } from './types';

export const STATE_OPTIONS: MutatePlayerOption[] = [
  { value: '', label: '' },
  ...[
    { value: 'GU', label: 'GU' },
    { value: 'MO', label: 'MO' },
    { value: 'PA', label: 'PA' },
    { value: 'AL', label: 'AL' },
    { value: 'HI', label: 'HI' },
    { value: 'MS', label: 'MS' },
    { value: 'PR', label: 'PR' },
    { value: 'AK', label: 'AK' },
    { value: 'IA', label: 'IA' },
    { value: 'MT', label: 'MT' },
    { value: 'RI', label: 'RI' },
    { value: 'ID', label: 'ID' },
    { value: 'NC', label: 'NC' },
    { value: 'SC', label: 'SC' },
    { value: 'AZ', label: 'AZ' },
    { value: 'IL', label: 'IL' },
    { value: 'ND', label: 'ND' },
    { value: 'SD', label: 'SD' },
    { value: 'AR', label: 'AR' },
    { value: 'IN', label: 'IN' },
    { value: 'NE', label: 'NE' },
    { value: 'TN', label: 'TN' },
    { value: 'CA', label: 'CA' },
    { value: 'KS', label: 'KS' },
    { value: 'NH', label: 'NH' },
    { value: 'TX', label: 'TX' },
    { value: 'CO', label: 'CO' },
    { value: 'KY', label: 'KY' },
    { value: 'NJ', label: 'NJ' },
    { value: 'UT', label: 'UT' },
    { value: 'CT', label: 'CT' },
    { value: 'LA', label: 'LA' },
    { value: 'NM', label: 'NM' },
    { value: 'VA', label: 'VA' },
    { value: 'DC', label: 'DC' },
    { value: 'MA', label: 'MA' },
    { value: 'NV', label: 'NV' },
    { value: 'VI', label: 'VI' },
    { value: 'DE', label: 'DE' },
    { value: 'MD', label: 'MD' },
    { value: 'NY', label: 'NY' },
    { value: 'VT', label: 'VT' },
    { value: 'FL', label: 'FL' },
    { value: 'ME', label: 'ME' },
    { value: 'OH', label: 'OH' },
    { value: 'WA', label: 'WA' },
    { value: 'GA', label: 'GA' },
    { value: 'MI', label: 'MI' },
    { value: 'OK', label: 'OK' },
    { value: 'WI', label: 'WI' },
    { value: 'MN', label: 'MN' },
    { value: 'OR', label: 'OR' },
    { value: 'WV', label: 'WV' },
    { value: 'WY', label: 'WY' },
  ].sort((a, b) => a.label.localeCompare(b.label)),
];

export const GENDER_OPTIONS: MutatePlayerOption[] = [
  { value: 'Unspecified', label: STRINGS.player.mutatePlayer.profile.playerGenderPlaceholder },
  { value: 'Male', label: STRINGS.player.mutatePlayer.profile.genderMale },
  { value: 'Female', label: STRINGS.player.mutatePlayer.profile.genderFemale },
];

export const LEVEL_OPTIONS: MutatePlayerOption[] = Array.from({ length: 10 }, (_, idx) => ({
  value: `level_${idx + 1}`,
  label: STRINGS.player.mutatePlayer.profile.levelLabel(idx + 1),
}));
